import React, { useState } from "react";
import { Panel } from "react-bootstrap";
import PanelBody from "react-bootstrap/lib/PanelBody";
import PanelHeading from "react-bootstrap/lib/PanelHeading";
import PanelTitle from "react-bootstrap/lib/PanelTitle";

import { useEventContext } from "../../../../context";
import locale from "../../../../locale";
import { eventModuleMainUpdate } from "../../../../../api/cp/eventModuleMain";

import AccessByIpSettings from "./AccessByIpSettings";
import AccessByCountrySettings from "./AccessByCountrySettings";

const ViewingRestrictionSettings = () => {
    const { event, setEvent } = useEventContext();
    const [isSaving, setSaving] = useState(false);

    const handleSaveEventModuleMain = async (data) => {
        setSaving(true);

        try {
            const moduleMain = await eventModuleMainUpdate(event.eventKey, data);
            setEvent(event => ({ ...event, moduleMain }));
        } catch (error) {
            console.error(error)
        } finally {
            setSaving(false);
        }
    };

    return (
        <Panel style={{ flex: 1 }}>
            <PanelHeading>
                <PanelTitle>Ограничение просмотра</PanelTitle>
            </PanelHeading>
            <PanelBody>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', columnGap: '4rem' }}>
                    <AccessByIpSettings
                        eventKey={event.eventKey}
                        locale={locale}
                        filter={event.moduleMain.ipFilter}
                        isSaving={isSaving}
                        onSaveFilter={handleSaveEventModuleMain}
                    />
                    <AccessByCountrySettings
                        eventKey={event.eventKey}
                        locale={locale}
                        filter={event.moduleMain.geoFilter}
                        isSaving={isSaving}
                        onSaveFilter={handleSaveEventModuleMain}
                    />
                </div>
            </PanelBody>
        </Panel>
    );
};

export default ViewingRestrictionSettings;
